import { useMutation, MutationResult } from '@apollo/client';
import gql from 'graphql-tag';
import { addToCategoryOnItem, addToCategoryOnItemVariables } from './__queries__';

const ADD_ITEM_TO_CATEGORY = gql`
  mutation addToCategoryOnItem($categoryId: ID!, $itemId: ID!) {
    addToCategoryOnItem(categoriesCategoryId: $categoryId, itemsItemId: $itemId) {
      category: categoriesCategory {
        id
        name
      }
      item: itemsItem {
        id
        title
      }
    }
  }
`;

interface Props {
  categoryId: string;
  itemId: string;
}

type UseAddItemToCategory = [
  ({ categoryId, itemId }: Props) => void,
  MutationResult<addToCategoryOnItem>,
];

export const useAddItemToCategory = (): UseAddItemToCategory => {
  const [addItemToCategory, addItemToCategoryResult] = useMutation<
    addToCategoryOnItem,
    addToCategoryOnItemVariables
  >(ADD_ITEM_TO_CATEGORY);

  const handleAddItemToCategory = ({ categoryId, itemId }: Props) => {
    addItemToCategory({
      variables: {
        categoryId,
        itemId,
      },
    });
  };

  return [handleAddItemToCategory, addItemToCategoryResult];
};
